/**
 * Import dependencies.
 */
import $ from 'jquery';
import 'slick-carousel';
import { breakpoints } from './variables';

function contentGridCarousel() {
	const gridCarousel = $('.is-carousel');

	gridCarousel.each( function () {
		const $this = $(this);
		const label = $this.parent().find('.layer__label');

		$this.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
	        mobileFirst: true,
	        arrows: true,
	        dots: false,
	        appendArrows: label.length > 0 ? label : $this,
	        nextArrow: '<button type="button" class="slick-next"><svg height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M12 52h62.344L52.888 73.456a4 4 0 1 0 5.657 5.656l28.283-28.284c.186-.186.352-.391.498-.609.067-.101.114-.21.172-.315.066-.124.142-.242.195-.373.057-.135.089-.275.129-.415.033-.111.076-.217.099-.331.052-.26.079-.522.079-.785l-.001-.009a4.032 4.032 0 0 0-.078-.774c-.024-.12-.069-.231-.104-.349-.039-.133-.069-.268-.123-.397-.058-.139-.136-.265-.208-.396-.054-.098-.097-.198-.159-.292a3.94 3.94 0 0 0-.501-.614L58.544 16.888a4.001 4.001 0 0 0-5.657 5.657L74.343 44H12a4 4 0 0 0 0 8z"/></svg>Next</button>',
	        prevArrow: '<button type="button" class="slick-prev"><svg height="96" width="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M84 44H21.656l21.456-21.456a4.001 4.001 0 0 0-5.657-5.657L9.172 45.171a3.996 3.996 0 0 0-.498.61c-.067.101-.114.21-.171.315-.067.124-.142.242-.196.373-.056.135-.088.276-.129.416-.032.111-.075.217-.098.331A3.98 3.98 0 0 0 8 48l.001.008c0 .259.027.519.078.774.024.121.069.232.104.349.039.133.07.268.123.397.058.139.136.265.208.396.054.098.096.198.159.292.147.221.314.427.501.614l28.282 28.281a4.001 4.001 0 0 0 5.657-5.657L21.657 52H84a4 4 0 0 0 0-8z"/></svg>Previous</button>',
	        responsive: [
	        	{
	                breakpoint: breakpoints.xs.min,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
	            },
	            {
	                breakpoint: breakpoints.sm.min,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
	            },
	            {
	                breakpoint: breakpoints.lg.min,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					}	                
	            }
	        ]
		});

		$(window).on('resize', function() {
	        $this.slick('resize');
	    });
	});

}

document.addEventListener('DOMContentLoaded', contentGridCarousel);